import Loading from '../../components/Loading';
import LoadMoreComponent from '../../components/LoadMoreComponent';

import CheckData from '../../components/CatchError';
import DataTable from '../../components/Datatable';
import AuthorModal from './Modal';
import { COLUMNS } from './keys';
import query from './query';
import { scrollForTable } from '../../components/Datatable/utils';
import MessageCustom from '../../components/MessageCustom';
import { withTranslation } from 'react-i18next';

const tabs = (t) => [
    {
        icon: 'icon-fi_grid',
        label: t('discover.authors.opportunities.tabs.all'),
        key: 'all',
        hint: 'icon-fi_grid',
    },
    {
        icon: 'icon-grid-03',
        label: t('discover.authors.opportunities.tabs.top_authors'),
        key: 'top_authors',
        hint: '',
    },
    {
        icon: 'icon-file-04',
        label: t('discover.authors.opportunities.tabs.striking_distance_authors'),
        key: 'striking_distance_authors',
        hint: '',
    },
    {
        icon: 'icon-intersect-circle',
        label: t('discover.authors.opportunities.tabs.top_Authors_with_little_content'),
        key: 'top_Authors_with_little_content',
        hint: '',
    },
];

class Summary extends LoadMoreComponent {
    constructor(props) {
        super();
        this.query = query({
            offset: 0,
            domain: props.domain,
            limit: props.plan_type === 'Basic' || props.plan_type === 'Trial' ? 5 : 100,
        });

        this.onToggle = this.onToggle.bind(this);

        this.loadMore = this.loadMore.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);

        this.offsetStep = 100;
    }

    onOpenModal() {
        this.setState({
            openAuthorModal: true,
        });
    }

    onCloseModal() {
        this.setState({
            openAuthorModal: false,
        });
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.author?.toLowerCase()?.includes(search.toLowerCase()));
    }

    onToggle(value) {
        let sortKey = 'median_impressions_per_author';
        if (value === 'all') {
            this.setState({
                sortedByToggle: false,
                sortedData: [],
            });
            sortKey = 'impressions';
        } else if (value === 'striking_distance_authors') {
            this.setState({
                sortedByToggle: true,
                sortedData: this.state.allData.filter((item) => item.pages >= 5 && item.pages <= 9),
            });
        } else if (value === 'top_authors') {
            this.setState({
                sortedByToggle: true,
                sortedData: this.state.allData.filter((item) => item.pages > 10),
            });
        } else {
            this.setState({
                sortedByToggle: true,
                sortedData: this.state.allData.filter((item) => item.pages < 5),
            });
        }

        this.setState({
            toggle: value,
            sortKey,
        });
    }

    render() {
        const { t } = this.props;

        if (this.state.loading && !this.state.loadMore) {
            return <Loading padding={10} />;
        }
        // if we get less than offsetStep it means we don't have more data
        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const attr = {
            query,
            offsetStep: this.offsetStep,
            domain: this.props.domain,
            start_date: this.start_date,
            end_date: this.end_date,
        };

        const sortFns = {
            author: (array) => array.sort((a, b) => a.author.localeCompare(b.author)),
            pages: (array) => array.sort((a, b) => a.pages - b.pages),
            entities: (array) => array.sort((a, b) => a.entities - b.entities),
            lifespan: (array) => array.sort((a, b) => a.lifespan - b.lifespan),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            avgWords: (array) => array.sort((a, b) => a.avgWords - b.avgWords),
            median_impressions_per_author: (array) =>
                array.sort(
                    (a, b) => a.median_impressions_per_author - b.median_impressions_per_author,
                ),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            avgctr: (array) =>
                array.sort((a, b) => a.clicks / a.impressions - b.clicks / b.impressions),
        };
        const data = this.state.sortedByToggle ? this.state.sortedData : this.state.allData;

        if (this.state.allData?.length === 1 && this.state.allData[0]?.author === 'NA') {
            this.showErrorMessage = true;
        } else {
            this.showErrorMessage = false;
        }

        return (
            <>
                {this.showErrorMessage && (
                    <MessageCustom message={t('discover.authors.errorMessage')} header="ALERT" />
                )}
                <div className="card rounded-main overflow-hidden opportunity-box">
                    <div className="card-body">
                        <div className="box-header">
                            {t('discover.authors.opportunities.header')}
                        </div>
                        <div className="opportunity-box-items">
                            {tabs(t).map((item) => (
                                <button
                                    key={item.key}
                                    type="button"
                                    className={`opportunity-box-item ${
                                        (this.state.toggle ?? 'all') === item.key ? 'active' : ''
                                    }`}
                                    title={item.hint}
                                    onClick={() => this.onToggle(item.key)}
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="card table-main rounded-main overflow-hidden">
                    <CheckData
                        content_id={this.props.content_id}
                        parent_id={this.props.parent_id}
                        data={data}
                        loading={this.state.loading}
                        loadMore={this.state.loadMore}
                    >
                        <DataTable
                            nodes={data}
                            sortFns={sortFns}
                            COLUMNS={COLUMNS(this.props.plan_type, this.onOpenModal, t)}
                            fileName={t('discover.authors.header')}
                            header={t('discover.authors.header')}
                            defaultSortKey={this.state.sortKey || 'impressions'}
                            forceRun={this.forceRun}
                            searchFunction={this.searchFunction}
                            showLoadMoreBtn={showLoadMoreBtn}
                            loadMoreLoading={this.state.loadMore}
                            loadMore={() => this.loadMore(attr)}
                            customEmptyMessage={t('discover.authors.customEmptyMessage')}
                            additionalStyles={{
                                Table: `
                                --data-table-library_grid-template-columns :  minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(150px, 1fr)  minmax(120px, 1fr) !important;
                                ${scrollForTable}
                            `,
                                BaseCell: `  font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px !important;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                            text-decoration: underline;
                                        }
                                        `,
                            }}
                        />
                    </CheckData>
                    <AuthorModal
                        isOpen={this.state.openAuthorModal}
                        onClose={this.onCloseModal}
                        plan_type={this.props.plan_type}
                    />
                    {this.props.message && this.propsredirectButton}
                </div>
            </>
        );
    }
}

export default withTranslation()(Summary);
